import news from "../services/engagement.news";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        newsDetails: null,
        newsImage: null,
        newsList: null,
        saving: false
    },
    mutations: {
        setIsLoading(state ,payload) {
            state.isLoading = payload;
        },
        setNewsDetails(state, payload) {
            if (payload) {
                state.newsDetails = {
                    title: payload.title,
                    content: payload.content,
                    image: payload.image,
                    web: payload.web,
                    mobile: payload.mobile,
                    glife: false,
                    published_date: payload.published_date,
                    is_draft: payload.is_draft,
                    show_button: payload.show_button,
                    buttons: !('buttons' in payload) || payload.buttons.length === 0
                        ? [{
                            "name": "View Products",
                            "color": "#FF8828",
                            "text_color": "#FFFFFF",
                            "redirect_to": "products"
                          }]
                        : payload.buttons,
                    show_popup: !!payload.pop_up,
                    uuid: payload.uuid
                };
            } else {
                state.newsDetails = null;
            }
        },
        setNewsImage(state ,payload) {
            state.newsImage = payload;
        },
        setNewsList(state ,payload) {
            state.newsList = payload;
        },
        SET_SAVING(state, value) {
            state.saving = value;
        }
    },
    getters: {
        saving: state => state.saving,
        newsDetails: state => state.newsDetails
    },
    actions: {
        getNewsDetails: async ({ commit }, uuid) => {
            commit("setIsLoading", true);
            try {
                const response = await news.getNewsDetails(uuid);
                commit("setNewsDetails", response.news);
                commit("setNewsImage", response.news.image);
                if (!!response.news.pop_up) {
                    const popup_details = response.news.pop_up;
                    commit("engagementPopup/setPopupDetails", popup_details, { root: true });
                    commit(popup_details.type === "poster" ? "engagementPopup/setPopupPoster" : "engagementPopup/setPopupBanner", popup_details.image, { root: true });
                }
            } catch (errors) {
                notification.warning("Oops, cannot get news details.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        createNews: async ({ commit }, payload) => {
            commit("setIsLoading", true);
            commit("setNewsDetails", null);
            try {
                const response = await news.createNews(payload);
                commit("setNewsDetails", response.news ? response.news : null);
                notification.success("News successfully created.");
            } catch (errors) {
                if (errors.message) notification.warning(errors.message);
                else notification.warning("Oops, cannot create pop up.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        updateNews: async ({ commit }, payload) => {
            commit("setIsLoading", true);
            commit("setNewsDetails", null);
            try {
                const response = await news.updateNews(payload);
                commit("setNewsDetails", response.news ? response.news : null);
                notification.success(response.message);
            } catch (errors) {
                if (errors.message) notification.warning(errors.message);
                else notification.warning("Oops, cannot create pop up.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        getNewsList: async ({ commit }, status) => {
            commit("setIsLoading", true);
            try {
                const response = await news.getNewsList(status);
                commit("setNewsList", response.designs);
            } catch (errors) {
                notification.warning("Oops, cannot get news list.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        deleteNews: async ({ commit }, uuid) => {
            commit("SET_SAVING", true);
            commit("errors", null);
            try {
                await news.deleteNews(uuid);
                notification.success("News successfully deleted.");
            } catch (errors) {
                commit("errors", errors.errors);
                notification.warning("Oops, cannot delete news item.");
            } finally {
                commit("SET_SAVING", false);
            }
        }
    }
};
